module.exports = __webpack_public_path__ + "img/product_jiantou.c17b24f6.png";